import {
  fromUTCtoZoneFormatted,
  STORE_KEY_LIST,
  storeGet
} from 'mailup-react-helpers'
import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'

import {
  Flex,
  FlexItem,
  Panel,
  SPACING_24,
  SPACING_4,
  SpacingVertical,
  Text,
  TEXT_VARIANT_LIGHT,
  Title,
  TITLE_VARIANT_S
} from 'mailup-web-components'

import { startConditionsDatesState } from '../recoil/state/workflow'

const StartConditionBlock = () => {
  const intl = useIntl()
  const { TimeZoneCode } = storeGet(STORE_KEY_LIST)

  const { firstExecutionDate, lastExecutionDate } = useRecoilValue(
    startConditionsDatesState
  )

  return (
    <Panel data-mu-test='workflow-statistics__start-condition'>
      <Title variant={TITLE_VARIANT_S}>
        {intl.formatMessage({
          id: 'Load.AutomationWorkflowTroubleshooting.StartCondition'
        })}
      </Title>
      <SpacingVertical variant={SPACING_24} />
      <Flex flexDirection='column' alignItems='flex-start'>
        <FlexItem margin='0 0 8px 0'>
          <Title variant={TITLE_VARIANT_S}>
            {intl.formatMessage({
              id: 'Load.AutomationWorkflowTroubleshooting.FirstExecution'
            })}
          </Title>
          <SpacingVertical variant={SPACING_4} />
          <Text variant={TEXT_VARIANT_LIGHT}>
            {firstExecutionDate
              ? fromUTCtoZoneFormatted(
                  firstExecutionDate,
                  TimeZoneCode,
                  'YYYY-MM-DD'
                )
              : '-'}
          </Text>
        </FlexItem>
        <FlexItem>
          <Title variant={TITLE_VARIANT_S}>
            {intl.formatMessage({
              id: 'Load.AutomationWorkflowTroubleshooting.LastExecution'
            })}
          </Title>
          <SpacingVertical variant={SPACING_4} />
          <Text variant={TEXT_VARIANT_LIGHT}>
            {lastExecutionDate
              ? fromUTCtoZoneFormatted(
                  lastExecutionDate,
                  TimeZoneCode,
                  'YYYY-MM-DD'
                )
              : '-'}
          </Text>
        </FlexItem>
      </Flex>
    </Panel>
  )
}

export default StartConditionBlock
